import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import filters from '../../../Shared/filters';
import computed from '../../../Shared/computed';
import EventBus from '@/Application/event-bus.js';
import careHelpfulFunctions from '../../careHelpfulFunctions.jsx';

import { QToolbar, QToolbarTitle, QSpace, QBtn, QIcon, QCard, QCardSection, QCardActions } from 'quasar';

/* We need a draggable dialog. Here is one possible solution:
 * https://github.com/vuetifyjs/vuetify/issues/4058
 *
 * We also need to support resizing, if I find something, I'll paste here.
 *
 * */

const BusyIcon = {
    components: { QIcon },
    render() {
        return (
            <QIcon
                name="mdi-cloud-download"
                size="sm"
                color="white"
                style={{ visibility: utils.global_variables.api_busy_indicator ? 'visible' : 'hidden' }}
            />
        );
    }
};

export default defineComponent({
    name: 'DisplayBasicConfirmModal',
    inheritAttrs: false,
    emits: ['closeme'],
    components: {
        BusyIcon,
        QToolbar,
        QToolbarTitle,
        QSpace,
        QBtn,
        QIcon,
        QCard,
        QCardSection,
        QCardActions
    },
    data: () => ({
        _uid: utils._uid_counter++,
        isbase: true,
        _allchildren: {},
        _children: [],
        vars: {},
        value: '',
    }),
    props: {
        name: '',
        root: null,
        type: null,
        parentType: '',
        action: null,
        context: null,
        c_context: null,
        controlData: { default: () => ({}) },
        scopeitems: null,
        controlscope: null,

        okay: null,
        cancel: null,
        accept: null,
    },
    created() {
        if (this.action.ActionData && this.action.ActionData.Vars) {
            const varsexpn = utils.compileObject(this, this.action.ActionData.Vars);
            try {
                this.vars = utils.evaluateObject(varsexpn, this.action.context);
            }
            catch (e) {
                utils.log('error evaluating Vars: ' + e);
            }
        }

        if (this.action.ActionData && this.action.ActionData.Javascript)
            try {
                const api = utils.apiWrapper; // apiService;
                const chf = careHelpfulFunctions;
                this.Javascript = utils.instantiateDynamicControllerScoped(this.action.ActionData.Javascript, { api, contextThis: this, chf }, 'null, null, api, contextThis, chf');

                for (let key in this.Javascript)
                    if (typeof this.Javascript[key] === 'function')
                        this.Javascript[key] = this.Javascript[key].bind(this.Javascript);
            }
            catch (e) {
                utils.warn(`Failed evaluating Javascript in ${this.name} ${this.type}: ${this.action.ActionData.Javascript}`, e);
            }


        // Subscribe to a UIAction_Close event, which then emits the close event
        // which is handled within ActionService.jsx, where it imbeds <dialog-basic-confirm-modal>
        utils.debug(`DialogBasicConfirmModal ${this.name} ${this._uid} $on ActionClose`);
        this.$on('Action-Close', this.performClose);
        EventBus.$on(`Action-Close:${this.name}`, this.performClose);
        EventBus.$on(`Action-Close`, this.performClose);
    },
    unmounted() {
        utils.debug(`DialogBasicConfirmModal ${this.name} ${this._uid} $off ActionClose`);
        this.$off('Action-Close', this.performClose);
        EventBus.$off(`Action-Close:${this.name}`, this.performClose);
        EventBus.$off(`Action-Close`, this.performClose);
    },
    mounted() {
    },
    computed: {
        ...computed,
        Base: function () {
            return this;
        },
        Name: function () {
            return this.name;
        },
        Root: function () {
            return this.root ? this.root : this;
        },
        Vars: function () {
            return this.vars;
        },
        title: function () {
            return this.action.title ? utils.evaluate(this.action.title, this.action.context) : '';
        },
        message: function () {
            return this.action.message ? utils.evaluate(this.action.message, this.action.context) : '';
        },
        okayButtonText: function () {
            return this.action.okaybuttontext ? utils.evaluate(this.action.okaybuttontext, this.action.context) : '';
        },
        cancelButtonText: function () {
            return this.action.cancelbuttontext ? utils.evaluate(this.action.cancelbuttontext, this.action.context) : '';
        }
    },
    methods: {
        ...methods,
        ...filters,
        async performClose(action) {
            utils.log(' ** Close Action Received by DialogBasicConfirmModal **');

            this.$emit('closeme');

            try {
                await utils.success(action);
            } catch (e) { }

            // Complete the promise for the executeAction method
            action.FinishFunc(true);
        },
        finishRenderHandler() { },
        clickedOutside(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    },
    render() {
        const dialogButtons = [];

        if (this.cancelButtonText)
            dialogButtons.push(
                <QBtn
                    outline
                    color="primary"
                    no-caps
                    class="c-SentenceCaseButton"
                    style="padding: 0 16px"
                    onClick={(e) => this.$emit('closeme', { Success: false, DialogResult: this.cancelButtonText })}
                >
                    <span>{this.cancelButtonText}</span>
                </QBtn>
            );

        if (this.okayButtonText)
            dialogButtons.push(
                <QBtn
                    unelevated
                    color="primary"
                    no-caps
                    class="c-SentenceCaseButton"
                    style="padding: 0 16px"
                    onClick={(e) => this.$emit('closeme', { Success: true, DialogResult: this.okayButtonText })}
                >
                    <span>{this.okayButtonText}</span>
                </QBtn>
            );

        let content = (
            <QCard>
                <QToolbar
                    class="bg-navigation text-white"
                    style={{ maxHeight: '60px', height: '60px', backgroundColor: 'var(--v-navigation-base)' }}
                >
                    <QToolbarTitle class="title text-white pl-0">
                        {this.title}
                    </QToolbarTitle>

                    <BusyIcon></BusyIcon>

                    <QBtn
                        flat
                        dense
                        color="white"
                        onClick={(e) => this.$emit('closeme')}
                    >
                        <QIcon name="mdi-close" />
                    </QBtn>
                </QToolbar>

                <QCardSection style="padding-top: 8px; white-space: pre-wrap">
                    {this.message}
                </QCardSection>

                <QCardActions align="right">
                    {dialogButtons}
                </QCardActions>
            </QCard>
        );

        return content;
    }
});
